import { createAPI } from '../common'

/**
 * 读图片(二进制流)
 * @param config
 * @returns {*}
 */
export function getImageFile(config) {
  return createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf', 'GET', config, {
    neverLoading: true,
    timeout: 120000
  })
}

/**
 * 读图片(BASE64)
 * @param config
 * @returns {AxiosPromise}
 */
export function getImages(config) {
  return createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhft', 'GET', config)
}

/**
 * 读文件
 * @param config
 * @returns {*}
 */
export function getFiles(config) {
  return createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60gjmft', 'GET', config)
}

//新建见报判断是否有创建权限
export function getIsAuthed(config) {
  return createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0jtBvuife', 'GET', config)
}

export function getDevices(config) {
  return createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbqfst0tzt0efwjdft', 'GET', config)
}
// 文件上传
export function uploadFile2(config) {
  return createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhft0vqmpbe3', 'POST', config)
}
export default {
  getImageFile,
  getImages,
  getFiles,
  getIsAuthed,
  getDevices,
  uploadFile2
}
